import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=754da0af&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=754da0af&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754da0af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754da0af')) {
      api.createRecord('754da0af', component.options)
    } else {
      api.reload('754da0af', component.options)
    }
    module.hot.accept("./BannerComponent.vue?vue&type=template&id=754da0af&scoped=true", function () {
      api.rerender('754da0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/BannerComponent.vue"
export default component.exports